import React from "react";

import home_security from "../assets/images/home-security.png";
import secondImg from "../assets/images/slideOne.jpg";
import bio_matrix from "../assets/images/bio-matrix.jpg";
import home_management from "../assets/images/home-management.jpg";
import audio_video from "../assets/images/audio-video.jpg";
import house_wiring from "../assets/images/slideFive.jpg";
import epabx_system from "../assets/images/slideFour.png";
import networking_solution from "../assets/images/netWorking-solution.jpg";
import wireLess_solution from "../assets/images/wireLess-solution.jpg";
import online_ups_one from "../assets/images/online-ups-one.jpg";
import online_ups_two from "../assets/images/online-ups-two.jpg";

const productDetails = () => {
  return (
    <>
      {/* CCTV SECURITY SYSTEM SOLUTION */}
      <div className="col-md-6 mt-5 ">
        <img src={home_security} alt="home_security" style={{ width: "90%" }} />
      </div>
      <div className="col-md-6 mt-5">
        <div className="info-heading">
          <h5
            style={{
              textDecoration: "underline",
            }}
          >
            CCTV SECURITY SYSTEM SOLUTION
          </h5>
          <ol type="1" className="mt-4">
            <li>Wireless Camera solution</li>
            <li>IP Camera solution</li>
            <li>HD Camera solution</li>
          </ol>
        </div>
      </div>

      <hr className="mt-3" />
      {/* FIRE ALARM SYSTEM */}
      <div className="col-md-6 ">
        <div className="info-heading">
          <h5
            style={{
              textDecoration: "underline",
            }}
          >
            FIRE ALARM SYSTEM
          </h5>
          <p className="mt-3">
            These alarms may be activated automatically from smoke detectors and
            heat detectors or may also be activate via manual fire alar
            activation device such as manual call points or pull stations
          </p>
          <ol type="1" className="mt-4">
            <li>Addressable Fire Alarm system</li>
            <li>Non Addressable Fire Alarm system</li>
          </ol>
        </div>
      </div>
      <div className="col-md-6 ">
        <img src={secondImg} alt="secondImg" style={{ width: "100%" }} />
      </div>
      <hr className="mt-3" />

      {/* BIO-MATRIX SOLUTION  */}

      <div className="col-md-6 ">
        <img src={bio_matrix} alt="bio_matrix" style={{ width: "100%" }} />
      </div>
      <div className="col-md-6 ">
        <div className="info-heading">
          <h5
            style={{
              textDecoration: "underline",
            }}
          >
            BIO-MATRIX SOLUTION
          </h5>
          <ol type="1" className="mt-4">
            <li>Face Recognition System</li>
            <li>Attendance System</li>
          </ol>
        </div>
      </div>
      <hr className="mt-3" />

      {/* HOME AUTOMATION */}
      <div className="col-md-6 ">
        <div className="info-heading">
          <h5
            style={{
              textDecoration: "underline",
            }}
          >
            HOME AUTOMATION
          </h5>
          <ol type="1" className="mt-4">
            <li>Smart Phone Control</li>
            <li>Voice Control</li>
            <li>Scheduling Timer</li>
            <li>Safe Material</li>
            <li>Group Control</li>
          </ol>
        </div>
      </div>
      <div className="col-md-6 ">
        <img
          src={home_management}
          alt="home_management"
          style={{ width: "100%" }}
        />
      </div>

      <hr className="mt-3" />

      {/*  AUDIO & VIDEO SOLUTION */}
      <div className="col-md-6 ">
        <img src={audio_video} alt="audio_video" style={{ width: "100%" }} />
      </div>
      <div className="col-md-6 ">
        <div className="info-heading">
          <h5
            style={{
              textDecoration: "underline",
            }}
          >
            AUDIO & VIDEO SOLUTION
          </h5>
          <ol type="1" className="mt-4">
            <li>Ceiling Speakers</li>
            <li>Rock Speakers</li>
            <li>Powerful Sound Bars</li>
            <li>Floor Stading architectural Speakers</li>
          </ol>
        </div>
      </div>

      <hr className="mt-3" />

      {/*  HOUSE WIRING */}
      <div className="col-md-6 ">
        <div className="info-heading">
          <h5
            style={{
              textDecoration: "underline",
            }}
          >
            HOUSE WIRING
          </h5>
          <ol type="1" className="mt-4">
            <li>Conduct Wiring</li>
            <li>Underground Wiring</li>
            <li>Wiring With Inveter And Battery</li>
            <li>Lighting</li>
          </ol>
        </div>
      </div>
      <div className="col-md-6 ">
        <img src={house_wiring} alt="house_wiring" style={{ width: "100%" }} />
      </div>

      <hr className="mt-3" />

      {/*  EPABX / IP PBX SYSTEM */}
      <div className="col-md-6 ">
        <img src={epabx_system} alt="epabx_system" />
      </div>

      <div className="col-md-6 ">
        <div className="info-heading">
          <h5
            style={{
              textDecoration: "underline",
            }}
          >
            EPABX / IP PBX SYSTEM
          </h5>
          <p className="mt-3">
            Telecommunication device that provides voice connectivity to desk
            phones within a building
          </p>
        </div>
      </div>

      <hr className="mt-3" />

      {/* NETWORKING SOLUTION */}

      <div className="col-md-12 ">
        <div className="info-heading">
          <img
            src={networking_solution}
            alt="networking_solution"
            style={{ width: "100%" }}
          />
        </div>
      </div>

      <hr className="mt-3" />
      {/* WIRELESS SOLUTION */}
      <div className="col-md-12">
        <img
          src={wireLess_solution}
          alt="wireLess_solution"
          style={{ width: "100%" }}
        />
      </div>

      <hr className="mt-3" />
      {/*   ONLINE UPS SYSTEM */}

      <div className="col-md-6 text-center">
        <img src={online_ups_two} alt="online_ups_two" />
      </div>

      <div className="col-md-6 text-center">
        <img src={online_ups_one} alt="online_ups_one" />
      </div>

      <div className="col-md-12 text-center">
        <div className="info-heading mt-3">
          <h5
            style={{
              textDecoration: "underline",
            }}
          >
            ONLINE UPS SYSTEM
          </h5>
          <p>
            Uninterruptible Power Supply is a device that supplies power in case
            of power failures. A UPS can be either Online UPS or Offline UPS.
            Both types of UPS can be used as a backup power source but there are
            many differences between them
          </p>
        </div>
      </div>

      <hr className="mt-3" />
    </>
  );
};

export default productDetails;
